import { render, staticRenderFns } from "./Sentences.vue?vue&type=template&id=912d8a3e&"
import script from "./Sentences.vue?vue&type=script&lang=js&"
export * from "./Sentences.vue?vue&type=script&lang=js&"
import style0 from "./Sentences.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports